<template>
  <path
    d="M14.71 15.8802L10.83 12.0002L14.71 8.12016C15.1 7.73016 15.1 7.10016 14.71 6.71016C14.32 6.32016 13.69 6.32016 13.3 6.71016L8.70998 11.3002C8.31998 11.6902 8.31998 12.3202 8.70998 12.7102L13.3 17.3002C13.69 17.6902 14.32 17.6902 14.71 17.3002C15.09 16.9102 15.1 16.2702 14.71 15.8802Z"
  />
</template>
